// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"cc926b0f","764":"2271b9a9"}[chunkId] + ".chunk.js";
};